/**
 * Connection API Client
 * Handles all API calls for Connection entities
 */

import { BaseApiClient, ApiResponse } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  Connection,
  CreateConnectionRequest,
  UpdateConnectionRequest,
  StandardListRequest,
  GetByIdRequest,
  DeleteRequest,
  SearchRequest,
} from '../types';

export class ConnectionApiClient extends BaseApiClient {
  async getAll(request: StandardListRequest = {}): Promise<ApiResponse<Connection[]>> {
    return this.post<Connection[]>(API_ENDPOINTS.CONNECTIONS.LIST, request);
  }

  async getById(request: GetByIdRequest): Promise<ApiResponse<Connection>> {
    return this.post<Connection>(API_ENDPOINTS.CONNECTIONS.GET_BY_ID, request);
  }

  async create(request: CreateConnectionRequest): Promise<ApiResponse<Connection>> {
    return this.post<Connection>(API_ENDPOINTS.CONNECTIONS.CREATE, request);
  }

  async update(request: UpdateConnectionRequest): Promise<ApiResponse<Connection>> {
    const { ConnectionID, ...updateData } = request;
    return this.put<Connection>(API_ENDPOINTS.CONNECTIONS.UPDATE(ConnectionID), updateData);
  }

  async deleteConnection(request: DeleteRequest): Promise<ApiResponse<void>> {
    return super.delete<void>(API_ENDPOINTS.CONNECTIONS.DELETE(request.id), { id: request.id });
  }

  async getByThreadVersion(versionId: number, request: SearchRequest = {}): Promise<ApiResponse<Connection[]>> {
    return this.postQuery<Connection[]>(API_ENDPOINTS.CONNECTIONS.BY_THREAD_VERSION, {
      ...request,
      ProcessThreadVersionID: versionId,
    });
  }

  async getBySourceElement(elementId: number, request: SearchRequest = {}): Promise<ApiResponse<Connection[]>> {
    return this.post<Connection[]>(API_ENDPOINTS.CONNECTIONS.BY_SOURCE_ELEMENT, {
      ...request,
      SourceProcessElementID: elementId,
    });
  }

  async getByTargetElement(elementId: number, request: SearchRequest = {}): Promise<ApiResponse<Connection[]>> {
    return this.post<Connection[]>(API_ENDPOINTS.CONNECTIONS.BY_TARGET_ELEMENT, {
      ...request,
      TargetProcessElementID: elementId,
    });
  }
}

export const connectionApiClient = new ConnectionApiClient();
